// Mirrors the backend's RestrictAccessExcept allowlist (publisher-service's
// gin.go) exactly — kept in sync since a mismatch here just means the UI shows
// access the backend will then reject, or hides access the backend would allow.
// Same list regardless of environment, matching the backend (no env branching there).
const ALLOWED_EMAILS = [
    'phil@e-diary.com',
    'sobhan@e-diary.com',
    'damon@e-diary.com',
    'patrick@e-diary.com',
    'jarad@e-diary.com',
];

export function isDevEmail (email) {
    const normalizedEmail = (email || '').toLowerCase();
    // Case-insensitive, matching the backend's strings.EqualFold comparison.
    return ALLOWED_EMAILS.some((allowed) => allowed.toLowerCase() === normalizedEmail);
}

/*
 * A superadmin whose own account is one of the allowed dev emails gets full
 * access to edit any publisher's restricted ECAL World fields, regardless of
 * that publisher's own email — everyone else (including a superadmin without
 * a dev email) stays scoped to the restricted-endpoint check on the
 * publisher's own email.
 */
export function hasSuperAdminDevAccess (isSuperAdmin, email) {
    return isSuperAdmin && isDevEmail(email);
}
